import * as React from 'react';
import { AppBanner } from '../AppBanner';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';


export const DashboardRedirectBanner: React.FC = () => {
    const { t } = useLanguageLocale();
    

    

    return (
        <AppBanner
            icon="ReportProblem"
            message={t('DASHBOARD.DASBOARD_REDIRECT_BANNER.MESSAGE', {
                
            })}
            buttons={[
             
            ]}
        />
    );
};
